export default __webpack_public_path__ + "static/media/template5.40ec23ed.svg";